import { Box, Paper, Typography } from '@mui/material';
import { ReactComponent as NotPermissionImage } from 'assets/not_permission.svg';
import { useNavigate } from 'react-router-dom';
import { FerramentasDeDetalhe } from 'shared/components';
import { LayoutBaseDePagina } from 'shared/layouts';

export const NotPermission: React.FC = () => {
  const navigate = useNavigate();
  return (
    <LayoutBaseDePagina
      titulo={'Sem permissão de acesso'}
      barraDeFerramentas={(
        <FerramentasDeDetalhe
          idForm='formDetalheDeWorkflow'
          mostrarBotaoNovo={false}
          mostrarBotaoApagar={false}
          mostrarBotaoGenerico={false}
          mostrarBotaoSalvar={false}

          aoClicarEmVoltar={() => navigate(-1)}
        />)
      }
    >
      <Box component={Paper} 
        variant="outlined" 
        flexDirection="column"
        sx={{ 
          m: 1, 
          width: 'auto', 
          display: 'flex',
          flexWrap: 'wrap'
        }}>
        <NotPermissionImage height={400} />
        <Typography
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipses"
          variant={'h5'}
          align='center'
          marginBottom={16}
        >
          Usuário sem permissão para acessar a página!
        </Typography>
      </Box >
    </LayoutBaseDePagina >
  );
};